module.exports = __webpack_public_path__ + "images/5-i449d6aec7dbddd08e08206a7d02855d9.svg";